import React, { useEffect } from "react";
import styles from './form.module.css'
import { GoSearch } from 'react-icons/go';
import { maskCurrency, maskPhone, maskZipCode, currencyToFloat, getNumbersByString, normalizeCpfCnpj, maskDocument, formatCurrency, formatPhoneNumber } from "../../utils/formatter";

const Input = ({ type, placeholder, value, onChange = () => { }, onKeyDown = () => { }, className = "", theme, required, disabled = false, autoFocus = false, maxLength, min, max, step, elementRef, invalid, textInvalid, ...props }) => {
    useEffect(() => {
        if (type === "currency") {
            const e = {
                target: {
                    value: formatCurrency(value)
                }
            }
            handleChange(e)
        }
    }, [])

    const handleChange = (e) => {
        if (type === "currency") {
            e.target.value = currencyToFloat(e.target.value)
        } else if (type === "phone") {
            e.target.value = `${formatPhoneNumber(e.target.value)}`
        } else if (type === "zipCode") {
            e.target.value = getNumbersByString(e.target.value)
        } else if (type === "document") {
            e.target.value = normalizeCpfCnpj(e.target.value).substring(0, 14)
        }
        onChange(e)
    }

    const getValue = () => {
        if (type === "currency") {
            return maskCurrency(value)
        } else if (type === "phone") {
            return maskPhone(value)
        } else if (type === "zipCode") {
            return maskZipCode(value)
        } else if (type === "document") {
            return maskDocument(value)
        }
        return value
    }

    const getInput = () => (
        <input
            type={type === "search" ? "text" : type}
            placeholder={placeholder}
            value={getValue()}
            onChange={handleChange}
            onKeyDown={onKeyDown}
            className={`${styles.input} ${styles[className] || ""} ${styles[theme] || ""} ${className}`.trim()}
            required={required}
            autoFocus={autoFocus}
            tabIndex={1}
            disabled={disabled}
            maxLength={maxLength}
            min={min}
            max={max}
            step={step}
            ref={elementRef}
            aria-invalid={invalid || undefined}
            data-validation-message={invalid ? textInvalid : undefined}
            {...props}
        />
    )

    return (
        <>
            {(type === "search" ?
                <div className={styles.divInput}>
                    {getInput()}
                    <div className={styles.iconSearch} onClick={() => onKeyDown({ key: 'Enter' })}>
                        <GoSearch />
                    </div>
                </div>
                :
                getInput()
            )}
        </>
    )
}

export default Input
